import axios from 'axios';
import { getSubdomain } from '@/helpers/util';
import { getApiRoot } from '@/helpers/api';

axios.defaults.baseURL = getApiRoot();
axios.defaults.headers.common['x-subdomain'] = getSubdomain();

export default axios;
